export default __webpack_public_path__ + "static/cherry_site_logo_red-1d72b5e43352f79f759cd960f9f3858c.png";